export default {"src":"/_next/static/media/shipping10.44b5df06.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};